import { IData } from '../Shared/common';
export interface IScreen extends IData {
  ID: number,
  Name: string,
  RoutingUrl: string,
  AbsoluteUrl: string,
  ScreenCode: number,
  Title: string,
  ParentScreenId: number,
  IsActive: boolean,
  IsVisible: boolean,
  NeedsAuth: boolean,
  CanView: boolean,
  CanAdd: boolean,
  CanEdit: boolean,
  CanDelete: boolean,
  HasSpecialPermissions: boolean,
  FullControl: boolean,
  IsAdminScreen :boolean,
  CloseOnSelection: boolean,
  IsSelected: boolean
}
export class Screen implements IScreen {
  ID: number;
  Name: string;
  RoutingUrl: string;
  AbsoluteUrl: string;
  ScreenCode: number;
  Title: string;
  ParentScreenId: number;
  IsActive: boolean;
  IsVisible: boolean;
  NeedsAuth: boolean;
  children: Screen[];
  RowNumber: number;
  CanView: boolean;
  CanAdd: boolean;
  CanEdit: boolean;
  CanDelete: boolean;
  HasSpecialPermissions: boolean;
  FullControl: boolean;
  IsAdminScreen: boolean;
  CloseOnSelection: boolean;
  IsSelected: boolean;
}
